import { PreloadedQuery } from "react-relay";

import { pricingPageRelayQuery } from "@/__generated_contentful__/pricingPageRelayQuery.graphql";
import { PricingContentContextProviderRelay } from "@/components/wpl/pricing/src/pricing-content-context.tsx";
import { PricingContent } from "@/utils/pricing-queries/get-pricing-content-gql.ts";
import { UserLocale } from "@/utils/useGeoCurrency.ts";

import { AppPricingData } from "../../../../contentful/index.tsx";
import { SoftwareCompassPricingPageTemplate } from "../../../../templates/software/compass/pricing/src/software-compass-pricing-page.template";

export type SoftwareCompassPricingPageProps = {
    pricing?: AppPricingData;
    countryCode?: UserLocale;
    pricingContent?: PricingContent;
    queryRef?: PreloadedQuery<pricingPageRelayQuery>;
};

export const SoftwareCompassPricingPage = ({
    pricing,
    countryCode,
    pricingContent,
    queryRef
}: SoftwareCompassPricingPageProps) => {
    return (
        <PricingContentContextProviderRelay
            productId="compass"
            pricingContent={pricingContent}
            queryRef={queryRef}
        >
            <div data-testid="compass-pricing-page">
                <SoftwareCompassPricingPageTemplate
                    pricing={pricing}
                    countryCode={countryCode}
                />
            </div>
        </PricingContentContextProviderRelay>
    );
};
